import {createAction} from '@reduxjs/toolkit'

import {OrderInterruptType} from '../interfaces'

export const orderInterrupted = createAction<OrderInterruptType[], 'order/interrupted'>('order/interrupted')
